import { render, staticRenderFns } from "./AuthSignupPhone.vue?vue&type=template&id=c13db6f6&scoped=true&"
import script from "./AuthSignupPhone.vue?vue&type=script&lang=ts&"
export * from "./AuthSignupPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13db6f6",
  null
  
)

export default component.exports